import React, { Component } from 'react';
import './../../assets/css/App.css';

class InputSearchField extends Component {

    state = {
        selectFieldValue: ""
    };

    componentDidMount () {
        this.fieldSelector = "#" + this.props.fieldId;
    };

    componentWillUnmount() {
        //$(this.fieldSelector).datepicker('destroy');
    }

    onInputFieldChange = (event) => {
        this.props.onChange(event.target.value);
        this.setState({
            selectFieldValue : event.target.value
        })
    }

    onInputFieldClearIconClick = (e) => {
        this.props.onChange("");
        this.setState({
            selectFieldValue : ""
        })
    }

    render() {
        return (
            <div className="float-left">
                <label htmlFor={this.props.fieldId} className="search-container button-right btn-info">
                    <input onChange={this.onInputFieldChange} type="search" id={this.props.fieldId}
                           placeholder={this.props.placeHolderText}
                           value={this.state.selectFieldValue}/>
                    {this.state.selectFieldValue === "" ? <i className="fa fa-search i-changes"/> :
                        <i onClick={this.onInputFieldClearIconClick} className="fa i-changes fa-times-circle" aria-hidden="true" />
                    }
                </label>
            </div>
        );
    }
}

export default InputSearchField;